import { Component, OnInit,Input } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { User } from '../../models/user';
import { UserService } from '../../services/user.service';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { TimeZoneService } from '../../services/timezone.service';
import { TimeZone } from '../../models/time-zone';


@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {
  publicating: boolean = false;
  user: User;
  @Input() UserID;
  @Input() nameComponent;
  @Input() Users;
  errorMessage:string;
  createUser: boolean = true;

  timezone: TimeZone;

  role = [
    {
      key:'admin',
      value:'Administrador'
    },
    {
      key:'user',
      value:'Usuario'
    },
    {
      key:'docchecker',
      value:'Verificador de Doc'
     }
    // {
    //   key:'freelancer',
    //   value:'Freelancer'
    // }
  ]

  status=[
    {
      id:1,
      name:'Activo',
    },
    {
      id:-2,
      name:'Inactivo',
    },
    {
      id:-6,
      name:'Eliminado',
    }
  ]

  constructor(
    public dialogRef: MdDialogRef<UsersComponent>,
    public userService: UserService,
    private dialog: MdDialog,
    public timeZoneService: TimeZoneService
  ) { }

  ngOnInit() {
    this.user = new User();
    this.timezone = {timezone: []};
    if (this.nameComponent === "Agregar"){
      this.createUser = true;
    } else {
      this.createUser = false;
    }
    if(this.Users.length > 0){
      //Load data user for ID
      this.getUser(this.UserID);
    } else {
      this.getUser(1);
    }
    this.getTimeZone();
  }

  getUser(id){
    for(let i = 0; i < this.Users.length; i++){
      if(id === this.Users[i].id){
        this.user = {
          id : this.Users[i].id,
          name : this.Users[i].name,
          email : this.Users[i].email,
          password : this.Users[i].password,
          password_repeat : this.Users[i].password_repeat,
          role : this.Users[i].role,
          status : this.Users[i].status,
          max_users : 0,
          total_users : 0,
          timezone : String(this.Users[i].timezone)
        };
      }
    }
  }

  onUser(){
    if (this.createUser) {
      this.onPostUser();
    } else {
      this.onPutUser();
    }
  }

  getTimeZone() {
    this.timeZoneService.getTimeZones()
    .subscribe(
      data => {
        this.timezone = {
          timezone: []
        };
        data.forEach(element => {
          this.timezone.timezone.push(String(element));
        });
      },
      error => {
        this.errorMessage = <any>error;
      }
    );
  }

  onPutUser() {
    this.publicating = true;
    this.userService.putUser(this.user)
      .subscribe(
        data => {
          this.Users = data;
          this.publicating = false;
          this.dialogRef.close('yes');
        },
        error => {
          let err = JSON.parse(error);
          let txterrors = JSON.parse(error);
          console.log(err);
          if (err.length > 0){
            err.forEach(function(element, index) {
                let err: any;
                let txterr: string = "";
                for(err in element.errors){
                  txterr = txterr+" "+element.errors[err][0];
                  console.log(element.errors[err][0]);
                }
                txterrors = txterrors+"<p class='bg-danger'>"+txterr+"</p>";

            });
          }
          this.errorMessage = <any>error;
          this.publicating = false;
          this.dialog.open(MessageBoxDialog, {data: {message: txterrors, alert: true, showIcon:true}});
        }
      );
  }

  onPostUser() {
    this.publicating = true;
    this.userService.postUser(this.user)
      .subscribe(
        data => {
          this.Users = data;
          this.publicating = false;
          this.dialogRef.close('yes');
        },
        error => {
          let err = JSON.parse(error);
          let err2 = err;
          let txterrors = "";
          console.log(err);
            for( let element in err) {
              console.log(err2[element]);
                let err: any;
                let txterr: string = "";
                for(let err in err2[element]){
                  txterr = txterr+" "+err2[element][err];
                  console.log(err);
                }
                txterrors = txterrors+", "+txterr;

            };
          this.errorMessage = <any>error
          this.publicating = false;
          this.dialog.open(MessageBoxDialog, {data: {message: txterrors, alert: true, showIcon:true}});
        }
      );
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/users/users.component.ts